module.exports = __webpack_public_path__ + "static/media/file-word.99f49409.svg";